import { Link } from 'react-router-dom';

const faqs = [
  {
    question: 'What exactly is Superbuy Spreadsheet?',
    answer: 'Superbuy Spreadsheet is a structured resource system that organizes product links, categories, prices, QC information, and shopping references in one convenient place. It helps international shoppers discover products faster without spending hours searching manually through countless listings.',
  },
  {
    question: 'How do I use Superbuy Spreadsheet?',
    answer: 'Simply browse through the organized categories, find products that interest you, and use the comparison guides to make informed decisions. Each category contains curated product links with relevant details to help you shop smarter.',
  },
  {
    question: 'Is Superbuy Spreadsheet free to use?',
    answer: 'Yes, the Superbuy Spreadsheet resource is freely accessible. We believe in making organized shopping resources available to everyone to improve their international shopping experience.',
  },
  {
    question: 'How often is the spreadsheet updated?',
    answer: 'The Superbuy Spreadsheet resources are regularly updated to ensure you have access to the latest product finds, current pricing information, and relevant shopping guides.',
  },
  {
    question: 'Can beginners use Superbuy Spreadsheet?',
    answer: 'Absolutely! Superbuy Spreadsheet is designed to be beginner-friendly with clear categories, step-by-step guides, and safety tips. Even if you have never shopped internationally before, you will find it easy to navigate.',
  },
  {
    question: 'How do I ensure safe shopping?',
    answer: 'Our Superbuy Spreadsheet includes QC photo guides, seller verification tips, and safety recommendations. Always review product details carefully, check seller ratings, and follow the safety guidelines provided in our comprehensive guide.',
  },
];

export default function FaqSection() {
  return (
    <section className="py-16 md:py-24 px-4 md:px-6 lg:px-10 bg-background-100/50">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-14">
          <span className="inline-block px-3 py-1 text-xs font-semibold text-secondary-700 bg-secondary-100/70 rounded-full mb-4 tracking-wide">
            FAQ
          </span>
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 mb-4">
            Frequently Asked Questions
          </h2>
          <p className="text-foreground-600 max-w-xl mx-auto text-sm md:text-base">
            Everything you need to know about Superbuy Spreadsheet
          </p>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, idx) => (
            <details key={idx} className="group rounded-xl border border-background-200/80 bg-background-50 overflow-hidden">
              <summary className="flex items-center justify-between px-6 py-4 cursor-pointer select-none">
                <span className="text-sm font-medium text-foreground-800 pr-4">{faq.question}</span>
                <span className="flex-shrink-0 w-6 h-6 flex items-center justify-center rounded-full bg-background-100 text-foreground-500 group-open:bg-primary-100 group-open:text-primary-600 transition-colors">
                  <i className="ri-add-line group-open:hidden text-sm"></i>
                  <i className="ri-subtract-line hidden group-open:block text-sm"></i>
                </span>
              </summary>
              <div className="px-6 pb-4">
                <p className="text-sm text-foreground-600 leading-relaxed">{faq.answer}</p>
              </div>
            </details>
          ))}
        </div>

        <div className="text-center mt-8">
          <Link
            to="/what-is-superbuy-spreadsheet"
            className="inline-flex items-center gap-2 text-sm font-semibold text-primary-700 hover:text-primary-800 transition-colors cursor-pointer"
          >
            View Complete FAQ Guide
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>

      {/* FAQ Schema */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: faqs.map((f) => ({
              '@type': 'Question',
              name: f.question,
              acceptedAnswer: {
                '@type': 'Answer',
                text: f.answer,
              },
            })),
          }),
        }}
      />
    </section>
  );
}